
<script setup>

import {ref, onUnmounted} from 'vue'

const closeDrawer = ref(false);
const emits = defineEmits(['update:open-drawer'])
const props = defineProps({

  openDrawer: {type: Boolean},
  title: {type: String, default: 'Title'},
  customData: {type: String, default: ''},
  height: {type: Number, default: 300},
})

function  handleClosing() {
      emits('update:open-drawer', false);
      closeDrawer.value = true;
      setTimeout(() => closeDrawer.value = false, 500);
    }

onUnmounted( () => {
  // Ensure the drawer closes when leaving pages
  if(props.openDrawer) emits('update:open-drawer', false);
})

</script>

<template>
  <div class="cmp-slide-in-drawer">
    <div class="cmp-slide-in-drawer_container">
      <div class="cmp-slide-in-drawer_content-wrapper" :style="{height: props.height + 'px'}"
           :class="{'cmp-slide-in-drawer_slide-close' : closeDrawer, 'cmp-slide-in-drawer_slide-open' : openDrawer}">
        <div class="cmp-slide-in-drawer_content-header">
          {{ title }} <span>{{ props.customData }}</span>
        </div>
        <div><hr/></div>
        <slot></slot>
        <div class="cmp-slide-in-drawer_footer" @click="handleClosing">
          <i class="fa-light fa-rectangle-xmark"></i>
        </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss" scoped>

.cmp-slide-in-drawer {

  &_container {
    position: relative;
    display: flex;
    height: 0;
    top: -116px;
    width: 100%;
    justify-content: center;
    z-index: 9999;
  }

  &_content-wrapper {
    position: relative;
    padding: 10px 10px 0 10px;
    display:none;
    background: #fcfcfc;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    box-shadow: 0 1px 4px 0 #888888;
  }

  &_content-header {
    background: var(--side-menu-color);
    color: var(--side-menu-text-color);
    padding: 10px;
  }

  &_footer {
    position: absolute;
    bottom: 0;
    cursor: pointer;
    right: 10px;
    font-size: 26px;
  }

  &_slide-open {
    display:block;
    animation: show_drawer 0.3s ease-in-out;
  }

  &_slide-close {
    display:block;
    animation: close_drawer 0.3s ease forwards;
  }

}

@keyframes show_drawer {
  0% {
    transform: translateY(-100%);
  }
}

@keyframes close_drawer {
  100% {
    transform: translateY(-110%);
  }
}

</style>
